/**
 * combos-stories.js — stories de clientes nas páginas de combos (snippet combos-stories).
 *
 * Bolinha por produto abre o visualizador em tela cheia: barras de progresso, toca com som (o toque na bolinha
 * libera o áudio; se o navegador bloquear, toca sem som e mostra "Toque para ativar o som"), tocar à direita/
 * esquerda avança/volta, segurar pausa, arrastar para baixo fecha, Esc fecha, setas navegam no computador.
 * O topo mostra a foto do vídeo atual e "1/4" (vídeo atual / total do produto); o anel da bolinha é dividido em um
 * pedaço por vídeo (CSS). Ao terminar os vídeos de um produto, passa para o próximo. "Ver combo" fecha e rola até o primeiro combo
 * com aquele produto ([data-cb-handles] nos combos). Um único <video> é reaproveitado (mantém a permissão de som).
 */
(function () {
  'use strict';

  if (window.CombosStories) return;

  var SEEN_KEY = 'cb-stories-seen';
  var HOLD_MS = 220;
  var SWIPE_CLOSE_PX = 90;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function readSeen() {
    try {
      return JSON.parse(window.localStorage.getItem(SEEN_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function markSeen(id) {
    try {
      var seen = readSeen();
      if (seen.indexOf(id) !== -1) return;
      seen.push(id);
      window.localStorage.setItem(SEEN_KEY, JSON.stringify(seen.slice(-50)));
    } catch (error) {
      // Sem armazenamento (aba anônima etc.): a bolinha só não fica cinza.
    }
  }

  function Stories(root) {
    var self = this;
    this.root = root;
    this.buttons = toArray(root.querySelectorAll('[data-cb-story]'));
    this.stories = this.buttons.map(function (btn) {
      var id = btn.getAttribute('data-cb-story-id');
      var videos = [];
      try {
        videos = JSON.parse(root.querySelector('[data-cb-story-videos="' + id + '"]').textContent);
      } catch (error) {
        console.error('Error in combos-stories videos:', error);
      }
      return {
        id: id,
        label: btn.getAttribute('data-cb-story-label'),
        target: btn.getAttribute('data-cb-story-target'),
        avatar: btn.getAttribute('data-cb-story-avatar'),
        videos: videos
      };
    });
    this.viewer = root.querySelector('[data-cb-viewer]');
    this.video = root.querySelector('[data-cb-viewer-video]');
    this.bars = root.querySelector('[data-cb-viewer-bars]');
    this.label = root.querySelector('[data-cb-viewer-label]');
    this.avatar = root.querySelector('[data-cb-viewer-avatar]');
    this.count = root.querySelector('[data-cb-viewer-count]');
    this.muteBtn = root.querySelector('[data-cb-viewer-mute]');
    this.hint = root.querySelector('[data-cb-viewer-unmute]');
    this.cta = root.querySelector('[data-cb-viewer-cta]');
    this.frame = root.querySelector('[data-cb-viewer-frame]');
    this.muted = false;
    this.si = -1;
    this.vi = 0;

    var seen = readSeen();
    this.buttons.forEach(function (btn, i) {
      if (seen.indexOf(btn.getAttribute('data-cb-story-id')) !== -1) btn.classList.add('is-seen');
      btn.addEventListener('click', function () { self.open(i, btn); });
    });

    this.video.addEventListener('timeupdate', this.progress.bind(this));
    this.video.addEventListener('ended', this.next.bind(this));
    root.querySelector('[data-cb-viewer-close]').addEventListener('click', this.close.bind(this));
    root.querySelector('[data-cb-viewer-prev-story]').addEventListener('click', function () { self.openStory(self.si - 1); });
    root.querySelector('[data-cb-viewer-next-story]').addEventListener('click', function () { self.openStory(self.si + 1); });
    this.muteBtn.addEventListener('click', function () { self.setMuted(!self.muted); });
    this.hint.addEventListener('click', function () { self.setMuted(false); });
    this.cta.addEventListener('click', this.goToCombo.bind(this));
    this.viewer.addEventListener('click', function (event) {
      if (event.target === self.viewer) self.close(); // clique fora do vídeo (computador)
    });
    this.bindGestures();
    document.addEventListener('keydown', function (event) {
      if (self.viewer.hidden) return;
      if (event.key === 'Escape') self.close();
      else if (event.key === 'ArrowRight') self.next();
      else if (event.key === 'ArrowLeft') self.prev();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && !self.viewer.hidden) self.video.pause();
    });
  }

  // Tocar à esquerda/direita navega; segurar pausa; arrastar para baixo fecha.
  Stories.prototype.bindGestures = function () {
    var self = this;
    var start = null;
    var holdTimer = null;
    var held = false;
    this.frame.addEventListener('pointerdown', function (event) {
      if (!event.target.closest('[data-cb-viewer-zone]')) return;
      start = { x: event.clientX, y: event.clientY };
      held = false;
      holdTimer = setTimeout(function () {
        held = true;
        self.video.pause();
      }, HOLD_MS);
    });
    function finish(event, cancelled) {
      if (!start) return;
      clearTimeout(holdTimer);
      var dy = event.clientY - start.y;
      var zone = event.target.closest && event.target.closest('[data-cb-viewer-zone]');
      start = null;
      if (held) {
        held = false;
        self.play();
        return;
      }
      if (cancelled) return;
      if (dy > SWIPE_CLOSE_PX) { self.close(); return; }
      if (zone) {
        if (zone.getAttribute('data-cb-viewer-zone') === 'prev') self.prev();
        else self.next();
      }
    }
    this.frame.addEventListener('pointerup', function (event) { finish(event, false); });
    this.frame.addEventListener('pointercancel', function (event) { finish(event, true); });
    // Os botões de zona recebem "click" também (teclado); o pointerup já navegou, então o click é ignorado.
    toArray(this.frame.querySelectorAll('[data-cb-viewer-zone]')).forEach(function (zone) {
      zone.addEventListener('click', function (event) {
        if (event.detail !== 0) return; // clique de mouse/toque: tratado no pointerup
        if (zone.getAttribute('data-cb-viewer-zone') === 'prev') self.prev();
        else self.next();
      });
    });
  };

  Stories.prototype.open = function (index, trigger) {
    this.trigger = trigger || null;
    this.viewer.hidden = false;
    this.prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    this.openStory(index);
    var close = this.viewer.querySelector('[data-cb-viewer-close]');
    setTimeout(function () { close.focus({ preventScroll: true }); }, 30);
  };

  Stories.prototype.openStory = function (index) {
    if (index < 0) index = 0;
    if (index >= this.stories.length) { this.close(); return; }
    var story = this.stories[index];
    this.si = index;
    this.label.textContent = story.label;
    if (story.avatar) this.avatar.setAttribute('src', story.avatar);
    this.bars.innerHTML = story.videos.map(function () { return '<span class="cb-viewer__bar"><i></i></span>'; }).join('');
    this.cta.hidden = !this.findCombo(story.target);
    this.viewer.querySelector('[data-cb-viewer-prev-story]').hidden = index === 0;
    this.viewer.querySelector('[data-cb-viewer-next-story]').hidden = index === this.stories.length - 1;
    markSeen(story.id);
    this.buttons[index].classList.add('is-seen');
    this.playVideo(0);
  };

  Stories.prototype.playVideo = function (vi) {
    var story = this.stories[this.si];
    this.vi = vi;
    toArray(this.bars.children).forEach(function (bar, i) {
      bar.firstChild.style.width = i < vi ? '100%' : '0%';
    });
    var item = story.videos[vi];
    var face = item.thumb || story.avatar;
    if (face) this.avatar.setAttribute('src', face);
    if (this.count) this.count.textContent = story.videos.length > 1 ? (vi + 1) + '/' + story.videos.length : '';
    this.video.setAttribute('poster', item.poster || '');
    this.video.src = item.src;
    this.video.muted = this.muted;
    this.play();
  };

  Stories.prototype.play = function () {
    var self = this;
    var attempt = this.video.play();
    if (!attempt || !attempt.catch) return;
    attempt.catch(function (error) {
      if (error && error.name === 'NotAllowedError' && !self.video.muted) {
        // Navegador bloqueou o som sem gesto: toca mudo e oferece ativar.
        self.setMuted(true, true);
        self.video.play().catch(function (err) { console.error('Error in combos-stories play:', err); });
      } else if (error && error.name !== 'AbortError') {
        console.error('Error in combos-stories play:', error);
      }
    });
  };

  Stories.prototype.setMuted = function (muted, showHint) {
    this.muted = muted;
    this.video.muted = muted;
    this.viewer.classList.toggle('is-muted', muted);
    this.muteBtn.setAttribute('aria-label', muted ? 'Ativar som' : 'Desativar som');
    this.hint.hidden = !(muted && showHint);
    if (!muted && this.video.paused && !this.viewer.hidden) this.play();
  };

  Stories.prototype.progress = function () {
    var bar = this.bars.children[this.vi];
    if (!bar || !this.video.duration) return;
    bar.firstChild.style.width = Math.min(100, this.video.currentTime / this.video.duration * 100) + '%';
  };

  Stories.prototype.next = function () {
    if (this.viewer.hidden) return;
    var story = this.stories[this.si];
    if (this.vi + 1 < story.videos.length) this.playVideo(this.vi + 1);
    else this.openStory(this.si + 1);
  };

  Stories.prototype.prev = function () {
    if (this.viewer.hidden) return;
    if (this.video.currentTime > 2 || (this.vi === 0 && this.si === 0)) {
      this.video.currentTime = 0;
      this.play();
    } else if (this.vi > 0) {
      this.playVideo(this.vi - 1);
    } else {
      this.openStory(this.si - 1);
    }
  };

  Stories.prototype.findCombo = function (handle) {
    if (!handle) return null;
    return document.querySelector('[data-cb-handles~="' + handle + '"]');
  };

  Stories.prototype.goToCombo = function () {
    var combo = this.findCombo(this.stories[this.si].target);
    this.close(true);
    if (combo) combo.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  Stories.prototype.close = function (keepFocus) {
    if (this.viewer.hidden) return;
    this.video.pause();
    this.video.removeAttribute('src');
    this.video.load(); // para o download do vídeo
    this.viewer.hidden = true;
    this.hint.hidden = true;
    document.documentElement.style.overflow = this.prevOverflow || '';
    if (keepFocus !== true && this.trigger) this.trigger.focus({ preventScroll: true });
  };

  function init(scope) {
    toArray((scope || document).querySelectorAll('[data-cb-stories]')).forEach(function (el) {
      if (!el.__cbStories) el.__cbStories = new Stories(el);
    });
  }

  window.CombosStories = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
